import { Workbox } from 'workbox-window';
import logger from 'debug';
import React from 'react';
import ReactDOM from 'react-dom';

const registerSW = async () => {
  const wb = new Workbox('./service-worker.js');
  let registration;

  wb.addEventListener('waiting', (event) => {
    logger('wastenot:info')('A new service worker has been installed and is waiting to activate.');
    wb.messageSW({ type: 'SKIP_WAITING' });
  });

  wb.addEventListener('controlling', () => {
    logger('wastenot:info')('New service worker has taken control. Reloading page.');
    const broadcast = new BroadcastChannel('sw-messages');
    broadcast.postMessage({ type: 'UPDATE_SUCCESS' });
    window.location.reload();
  });

  wb.addEventListener('activated', () => {
    logger('wastenot:info')('Service worker activated and ready.');
  });
  
  // receive postMessage from SW (ie data was sync'd)
  wb.addEventListener('message', (event) => {
    logger('wastenot:info')('Message received: ', event.data);
    const { name, date } = event.data;
    const syncEvent = new CustomEvent(name, { detail: { date } });
    window.dispatchEvent(syncEvent);
  });

  // empty the replay queue, which holds our offline wasteEntry records
  window.addEventListener('REPLAY_REQUESTS', () => {
    wb.messageSW({ type: 'REPLAY_REQUESTS' });
  });

  // Register the service worker
  try {
    registration = await wb.register();
  } catch (error) {
    logger('wastenot:error')('Service worker registration failed:', error);
  }

  // Check for updates every 45 minutes
  setInterval(async () => {
    logger('wastenot:info')('Checking for updates...');
    if (registration) {
      try {
        await registration.update();
        logger('wastenot:info')('Update check completed');
      } catch (error) {
        logger('wastenot:error')('Update check failed:', error);
      }
    }
  }, 45 * 60 * 1000);
};

export default registerSW;